/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, Link, TextStyle, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import { ExternalMinor } from '@shopify/polaris-icons';

type State = {
  dismissedBanner: boolean
};

class DidYouKnow extends Component<WithI18nProps, State> {
  render() {
    const { i18n } = this.props;

    return (
      <Banner title={i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.title')} status="info">
        <p>{i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content01_v3')}</p>
        <p>
          {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content02', {
            t1: (
              <span className='img-new-tab'>
                <Link external url={`${URL['ThemeSetupV3Doc_use']}`}>
                  {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content02_t1')}
                  <Icon source={ExternalMinor} color="base" />
                </Link>
              </span>
            ),
            t2: (
              <span className='img-new-tab'>
                <Link external url={`${URL['ThemeSetupV3Doc_revert']}`}>
                  {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content02_t2')}
                  <Icon source={ExternalMinor} color="base" />
                </Link>
              </span>
            )
          })}
        </p>
        <p style={{ marginTop: '1.25rem' }}>
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Common.Title.important')}
          </TextStyle>{' '}
          {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content03', {
            t1: (
              <span className='img-new-tab'>
                <Link external url={`${URL['ThemeSetupV3Doc_list_support']}`}>
                  {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content03_t1')}
                  <Icon source={ExternalMinor} color="base" />
                </Link>
              </span>
            ),
            t2: (
              <span className='img-new-tab'>
                <Link external url={`${URL['ThemeSetupV3Doc_default_layout']}`}>
                  {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content03_t2')}
                  <Icon source={ExternalMinor} color="base" />
                </Link>
              </span>
            ),
            t3: (
              <span className='img-new-tab'>
                <Link external url={`${URL['ThemeSetupV3Doc_FAQ']}`}>
                  {i18n.translate('AdminHTML.ThemeSetup.DidYouKnow.content03_t3')}
                  <Icon source={ExternalMinor} color="base" />
                </Link>
              </span>
            )
          })}
        </p>
      </Banner>
    );
  }
}

export default withI18n()(DidYouKnow);
